if (!customElements.get('contact-widget')) {
  customElements.define(
    'contact-widget',
    class ContactWidget extends DetailsDisclosure {
      constructor() {
        super();

        this.elements = {
          contactWidgetButton: this.querySelector('.contact-widget-button__button'),
          widgetSummary: this.querySelector('summary'),
          closeButton: this.querySelector('.contact-widget-button__close'),
          widgetButton: this.querySelector('.button.button--rounded'),
          callButton: this.querySelector('.contact-widget-button__phone'),
          whatsappButton: this.querySelector('.contact-widget-button__whatsapp'),
          emailButton: this.querySelector('.contact-widget-button__email'),
          calendlyButton: this.querySelector('.contact-widget-button__calendly'),
          contactButton: this.querySelector('.contact-widget-button__contact'),
          contactWidgetLabel: this.querySelector('.contact-widget-button__button__tooltip'),
          //successMessage: this.querySelector('[id^="ShareMessage"]'),
          //urlInput: this.querySelector('input'),
        };
        //this.urlToShare = this.elements.urlInput ? this.elements.urlInput.value : document.location.href;
        //this.widgetButton.addEventListener('click', closeWidget());

        // TRACKING
        this.elements.callButton.addEventListener('click', () => {
          Shopify.analytics.publish('call_btn_click', { link_url: document.location.href });
        });
        this.elements.emailButton.addEventListener('click', () => {
          Shopify.analytics.publish('email_btn_click', { link_url: document.location.href });
        });
        this.elements.whatsappButton.addEventListener('click', () => {
          Shopify.analytics.publish('whatsapp_btn_click', { link_url: document.location.href });
        });
        this.elements.calendlyButton.addEventListener('click', () => {
          Shopify.analytics.publish('calendly_btn_click', { link_url: document.location.href });
        });
        this.elements.contactButton.addEventListener('click', () => {
          Shopify.analytics.publish('contact_btn_click', { link_url: document.location.href });
        });

        /*
        if (navigator.share) {
          this.mainDetailsToggle.setAttribute('hidden', '');
          this.elements.contactWidgetButton.classList.remove('hidden');
          //this.elements.shareButton.addEventListener('click', () => {
          //navigator.share({ url: this.urlToShare, title: document.title });
          });
        } else {
          this.mainDetailsToggle.addEventListener('toggle', this.toggleDetails.bind(this));
          //this.mainDetailsToggle
          //.querySelector('.share-button__copy')
          //.addEventListener('click', this.copyToClipboard.bind(this));
          //this.mainDetailsToggle.querySelector('.contact-widget-button__close').addEventListener('click', this.close.bind(this));
        }
        */

        this.lastActiveTime = new Date();
        window.onclick = function () {
          this.lastActiveTime= new Date();
        };
        window.onmousemove = function () {
          this.lastActiveTime= new Date();
        };
        window.onkeypress = function () {
          this.lastActiveTime= new Date();
        };
        window.onscroll = function () {
          this.lastActiveTime= new Date();
        };
        let idleTimer_k = window.setInterval(CheckIdleTime, 5000);

        function CheckIdleTime() {
          //returns idle time every 5 seconds
          let dateNowTime = new Date().getTime();
          if (isNaN(this.lastActiveTime)) {
            let lastActiveTime = new Date();
          } 
          let lastActiveTime = new Date(this.lastActiveTime).getTime();
          let remTime = Math.floor((dateNowTime-lastActiveTime)/ 2000);

          // converting from milliseconds to seconds
          //console.log("Idle since "+remTime+" Seconds Last active at "+this.lastActiveTime);

          if (remTime > 2) {
            document.querySelector('.contact-widget-button__button__tooltip').classList.add("animate");
          } else {
            document.querySelector('.contact-widget-button__button__tooltip').classList.remove("animate");
          }
        }
      }

      closeWidget() {
        document.getElementsByClassName("contact-widget-button__close").click();
      }

      toggleDetails() {
        if (!this.mainDetailsToggle.open) {
          /*this.elements.successMessage.classList.add('hidden');
          this.elements.successMessage.textContent = '';*/
          //this.elements.closeButton.classList.add('hidden');
          this.elements.widgetSummary.focus();
        }
        /*if (this.mainDetailsToggle.open) {
          this.elements.closeButton.classList.remove('hidden');
        }*/
      }
    }
  );
}
